import { ALL_DEPARTMENTS_ID } from '../config'

const extractDepartments = (jobs) => {
  const departments = {
    [`${ALL_DEPARTMENTS_ID}`]: {
      id: ALL_DEPARTMENTS_ID,
      label: 'All',
      availableJobs: 0,
    },
  }

  if (jobs?.length) {
    jobs.forEach((job) => {
      departments['0'].availableJobs += 1

      const division = job.customField.find((customField) => customField.fieldLabel === 'Division')

      if (!division) {
        return
      }

      const { valueId: id, valueLabel: label } = division

      if (!departments[id]) {
        departments[id] = {
          id,
          label,
          availableJobs: 1,
        }

        return
      }

      departments[id].availableJobs += 1
    })
  }

  const listOfDepartments = Object.values(departments).sort((a, b) => a.label.localeCompare(b.label))

  return listOfDepartments
}

export { extractDepartments }
